import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export interface AlertPreviewTheme {
  container: {
    backgroundColor: string;
    boxShadow: string;
  };
  header: {
    container: {
      backgroundColor: string;
      boxShadow: string;
    };
    tag: {
      backgroundColor: string;
      textColor: string;
    };
    description: {
      color: string;
    };
    modelIcon: {
      backgroundColor: string;
      textColor: string;
    };
    modelName: {
      color: string;
    };
  };
  controls: {
    viewControls: {
      backgroundColor: string;
      boxShadow: string;
    };
    actions: {
      backgroundColor: string;
      boxShadow: string;
    };
    actionLabel: {
      color: string;
    };
    primaryButton: {
      backgroundColor: string;
      borderColor: string;
    };
  };
}

export const alertPreviewTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        backgroundColor: theme.color.surface[2],
        boxShadow: `0px 0px 6px 0px ${theme.color.neutral.grey.transparent['k-15%']}`,
      },
      header: {
        container: {
          backgroundColor: theme.color.surface[1],
          boxShadow: `0px 1px 2px 0px ${theme.color.neutral.grey.transparent['k-20%']}`,
        },
        tag: {
          backgroundColor: theme.color.surface[4],
          textColor: theme.color.text.core['-primary'],
        },
        description: {
          color: theme.color.text.core['-primary'],
        },
        modelIcon: {
          backgroundColor: theme.color.lighting['ai-teal'],
          textColor: theme.color.text.core['-primary'],
        },
        modelName: {
          color: theme.color.text.core['-primary'],
        },
      },
      controls: {
        viewControls: {
          backgroundColor: theme.color.surface[0],
          boxShadow: `0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1),
    inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1)`,
        },
        actions: {
          backgroundColor: theme.color.surface[0],
          boxShadow: `0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1),
    inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1)`,
        },
        actionLabel: {
          color: theme.color.text.core['-primary'],
        },
        primaryButton: {
          backgroundColor: theme.color.surface[2],
          borderColor: theme.color.surface[4],
        },
      },
    },
  ]),
);
